type MailtoArgs = {
  to?: string | string[];
  cc?: string | string[];
  bcc?: string | string[];
  subject?: string;
  body?: string;
  extras?: Record<string, string | undefined>;
};

export function createMailto(args: MailtoArgs): string {
  const { to, cc, bcc, subject, body, extras } = args ?? {};

  const joinAddrs = (v?: string | string[]) =>
    Array.isArray(v) ? v.filter(Boolean).join(',') : (v ?? '');

  const toStr = joinAddrs(to) || '';
  const ccStr = joinAddrs(cc);
  const bccStr = joinAddrs(bcc);

  const parts: string[] = [];

  // Encode all parameters EXCEPT body to prevent double encoding
  // URLSearchParams automatically encodes values, but we're building manually
  // to avoid double-encoding of the body parameter
  if (subject) parts.push(`subject=${encodeURIComponent(subject)}`);
  if (ccStr) parts.push(`cc=${encodeURIComponent(ccStr)}`);
  if (bccStr) parts.push(`bcc=${encodeURIComponent(bccStr)}`);
  if (body) parts.push(`body=${encodeURIComponent(body)}`);

  if (extras) {
    Object.entries(extras).forEach(([k, v]) => {
      if (v != null) parts.push(`${k}=${encodeURIComponent(v)}`);
    });
  }

  const query = parts.join('&');

  return `mailto:${toStr}${query ? `?${query}` : ''}`;
}

export function formatEmailBody(body: string): string {
  if (!body) return '';

  // Replace <br> and <br/> with line breaks
  let formatted = body.replace(/<br\s*\/?>/gi, '\n');

  // Remove other HTML tags (but keep the already added line breaks)
  formatted = formatted.replace(/<[^>]*>?;?/g, '');

  return formatted;
}
